import React from "react";
import styles from "./ShipDeckPlanSlide.module.scss";
import clsx from "clsx";

export type ShipDeckPlanSlideProps = {
  color?: string;
  title?: string;
  caption: string;
  className?: string;
};

export const ShipDeckPlanSlide: React.FC<
  React.PropsWithChildren<ShipDeckPlanSlideProps>
> = ({ color, title, caption, children, className }) => {
  return (
    <div>
      <div className={clsx(styles.legend, className)}>
        {color && (
          <span
            className={styles.colorLegend}
            style={{ backgroundColor: `#${color}` }}
          >
            {" "}
          </span>
        )}
        {title && <span>{title}</span>}
        <span className={styles.deckNumber}>{caption}</span>
      </div>
      {children}
    </div>
  );
};
